import {CLIENT_CALL_TYPE_MAP, type ClientCallType} from '@pexip/infinity';

export const getClientCallType = (
    input: string | undefined,
): ClientCallType | undefined =>
    CLIENT_CALL_TYPE_MAP.get(String(input).toLowerCase());
